<template>
  <div class="flex items-center space-x-3">
    <div class="absolute right-0 cursor-pointer top-2" @click.stop="openModalNotes">
      <NotesIcon class="w-5 h-5 mr-2 hover:opacity-100" />
      <div class="flex justify-center items-center absolute left-0.5 top-0">
        <div class="flex items-center justify-center w-4 h-4 text-xs font-bold text-center text-white rounded-full">
          <Plus v-if="notes_count === 0" class="w-5 h-5 text-white transition" />
          <div v-else>
            {{ notes_count }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="cursor-pointer"
      @click="pageReference !== 'company_profile' && pageReference !== 'object_profile' ? $utils.Record(component_record).open() : null">
      <Logo v-if="!$utils.Record(component_record).logo" class="inline-block w-20 h-20 p-3 rounded-md cursor-default" />
      <img v-else class="inline-block object-contain h-24 p-3 rounded-lg" :src="`${$utils.Record(component_record).logo}`" alt="">
    </div>
    <div>
      <div
        class="text-2xl font-medium cursor-pointer"
        @click="pageReference !== 'company_profile' && pageReference !== 'object_profile' ? $utils.Record(component_record).open() : null">
        {{ $utils.getRecordName(component_record) }}
      </div>

      <div
        v-for="tag in component_record?.tags"
        :key="tag"
        :style="{
          backgroundColor: `${$store.state.data.tags.find((t) => t.id == tag).color}12`
        }"
        class="inline-block px-2 mt-3 mr-3 rounded-md">
        <div
          class="w-[10px] h-[10px] rounded-full inline-block mt-0 mr-2 text-transparent"
          :style="{
            backgroundColor: $store.state.data.tags.find((t) => t.id == tag).color
          }" />
        <span :style="{ color: $store.state.data.tags.find((t) => t.id == tag).color }" class="text-sm">{{
          $store.state.data.tags.find((t) => t.id == tag).name
        }}</span>
      </div>

      <div
        class="inline-block px-2 mt-3 bg-gray-100 rounded-md cursor-pointer"
        @click="
          $emitter.emit('assignTags', {
            record: component_record,
            object_type: component_record.type
          })
        ">
        <span class="text-sm"><span class="font-bold">+</span> {{ $t("Add Tag") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useLayoutItemSharedLogic } from "@/components/shared/pages/useLayoutItemSharedLogic.js"
import dataService from "@/services/data.service"
import Logo from "@/components/shared/Logo.vue"
import NotesIcon from "@/components/shared/icons/NotesIcon.vue"
import { Plus } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { Logo, NotesIcon, Plus },
  props: {
    linkedRecord: {
      type: String,
      required: false
    },
    connectTo: {
      type: String,
      required: false
    },
    pageReference: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      notes_count: 0,
      company_summary: null,
      // Shared logic
      loading: false,
      record_error: false,
      component_record: null
    }
  },
  created() {
    const { loading, record_error, component_record } = useLayoutItemSharedLogic(
      this.$props,
      this.postGetComponentRecord,
      this.registerListeners,
      this.unregisterListeners
    )
    this.loading = loading
    this.record_error = record_error
    this.component_record = component_record
  },
  methods: {
    // Custom logic after getting the component record
    postGetComponentRecord() {
      dataService.getCompanySummary(this.component_record?.id).then((res) => {
        this.company_summary = res.data
      })

      this.$store.dispatch("data/getRecordNotes", this.component_record.id).then((result) => {
        this.notes_count = result.data.results.length
      })
    },

    // Custom listener for this component
    registerListeners() {
      this.$emitter.on(ALL_EMITTERS.UPDATE_COUNT_NOTES_IN_RECORDS_TABLE, ({ id, count }) => {
        if (this.component_record?.id === id) {
          this.notes_count = count
        }
      })
    },
    unregisterListeners() {
      this.$emitter.off(ALL_EMITTERS.UPDATE_COUNT_NOTES_IN_RECORDS_TABLE)
    },
    // Opening the modal for notes
    openModalNotes() {
      this.$emitter.emit(ALL_EMITTERS.ADD_NOTES_RECORD, { company: this.component_record })
    }
  }
}
</script>
